import {
    HOSPITAL_EVALUATION_LIST,
    HOSPITAL_EVALUATION_LIST_SUCCESS,
    HOSPITAL_EVALUATION_LIST_ERROR,
    HOSPITAL_EVALUATION_DESTINATION,
    HOSPITAL_EVALUATION_DESTINATION_SUCCESS,
    HOSPITAL_EVALUATION_DESTINATION_ERROR,
    HOSPITAL_EVALUATION_AREA,
    HOSPITAL_EVALUATION_AREA_SUCCESS,
    HOSPITAL_EVALUATION_AREA_ERROR,
    HOSPITAL_EVALUATION_JOB,
    HOSPITAL_EVALUATION_JOB_SUCCESS,
    HOSPITAL_EVALUATION_JOB_ERROR,
    HOSPITAL_EVALUATION_ADD_MODAL_SET,
    HOSPITAL_EVALUATION_ADD_CHANGE_SET,
    HOSPITAL_EVALUATION_ADD,
    HOSPITAL_EVALUATION_ADD_SUCCESS,
    HOSPITAL_EVALUATION_ADD_ERROR,
    HOSPITAL_EVALUATION_TAB_SET,
    HOSPITAL_EVALUATION_CAPACITY_INSTALL,
    HOSPITAL_EVALUATION_CAPACITY_INSTALL_SUCCESS,
    HOSPITAL_EVALUATION_CAPACITY_INSTALL_ERROR,
    HOSPITAL_EVALUATION_INFRASTRUCTURE,
    HOSPITAL_EVALUATION_INFRASTRUCTURE_SUCCESS,
    HOSPITAL_EVALUATION_INFRASTRUCTURE_ERROR,
    HOSPITAL_EVALUATION_HUMAN_TALENT,
    HOSPITAL_EVALUATION_HUMAN_TALENT_SUCCESS,
    HOSPITAL_EVALUATION_HUMAN_TALENT_ERROR,
    HOSPITAL_EVALUATION_PRODUCTION,
    HOSPITAL_EVALUATION_PRODUCTION_SUCCESS,
    HOSPITAL_EVALUATION_PRODUCTION_ERROR,
    HOSPITAL_EVALUATION_AVAILABILITY,
    HOSPITAL_EVALUATION_AVAILABILITY_SUCCESS,
    HOSPITAL_EVALUATION_AVAILABILITY_ERROR
} from "../../actions";

const INIT_STATE = {
    loading: false,
    list: {
        page: {
            current: 1,
            rows: 10
        }
    },
    destination: {
        loading: false,
        data: []
    },
    area: {
        loading: false,
        data: []
    },
    job: {
        loading: false,
        data: []
    },
    capacityinstall: {
        loading: false,
        data: []
    },
    infrastructure: {
        loading: false,
        data: []
    },
    humantalent: {
        loading: false,
        data: []
    },
    production: {
        loading: false,
        data: []
    },
    availability: {
        loading: false,
        data: []
    },
    add: {
        data: [],
        modal: false,
        loading: false,
        message: '',
        url: '',
        type: ''
    },
    viewtab: {
        tab: '1',
        modal: false
    },
    error: false,
    search: {
    }
};

export default (state = INIT_STATE, action) => {
    switch (action.type) {

        case HOSPITAL_EVALUATION_LIST:
            return {
                ...state,
                loading: true,
                list: {
                    ...state.list
                }
            }
        case HOSPITAL_EVALUATION_LIST_SUCCESS:
            return {
                ...state,
                loading: false,
                list: {
                    ...state.list,
                    ...action.payload
                }
            }
        case HOSPITAL_EVALUATION_LIST_ERROR:
            return {
                ...state,
                loading: false,
                error: true
            }
        case HOSPITAL_EVALUATION_DESTINATION:
            return {
                ...state,
                loading: true,
                destination: {
                    ...state.destination
                }
            }
        case HOSPITAL_EVALUATION_DESTINATION_SUCCESS:
            return {
                ...state,
                loading: false,
                destination: {
                    ...state.destination,
                    ...action.payload
                }
            }
        case HOSPITAL_EVALUATION_DESTINATION_ERROR:
            return {
                ...state,
                loading: false,
                error: true
            }
        case HOSPITAL_EVALUATION_AREA:
            return {
                ...state,
                loading: true,
                area: {
                    ...state.area
                }
            }
        case HOSPITAL_EVALUATION_AREA_SUCCESS:
            return {
                ...state,
                loading: false,
                area: {
                    ...state.area,
                    ...action.payload
                }
            }
        case HOSPITAL_EVALUATION_AREA_ERROR:
            return {
                ...state,
                loading: false,
                error: true
            }
        case HOSPITAL_EVALUATION_JOB:
            return {
                ...state,
                loading: true,
                job: {
                    ...state.job
                }
            }
        case HOSPITAL_EVALUATION_JOB_SUCCESS:
            return {
                ...state,
                loading: false,
                job: {
                    ...state.job,
                    ...action.payload
                }
            }
        case HOSPITAL_EVALUATION_JOB_ERROR:
            return {
                ...state,
                loading: false,
                error: true
            }
        case HOSPITAL_EVALUATION_ADD_MODAL_SET:
            return {
                ...state,
                add: {
                    ...state.add,
                    modal: action.payload
                }
            }
        case HOSPITAL_EVALUATION_ADD_CHANGE_SET:
            return {
                ...state,
                add: {
                    ...state.add,
                    data: {
                        ...state.add.data,
                        ...action.payload
                    }
                }
            }
        case HOSPITAL_EVALUATION_ADD:
            return {
                ...state,
                add: {
                    ...state.add,
                    loading: false
                }
            }
        case HOSPITAL_EVALUATION_ADD_SUCCESS:
            return {
                ...state,
                add: {
                    ...state.add,
                    modal: false,
                    loading: false,
                    url: action.payload.url,
                    type: action.payload.type,
                    message: action.payload.message
                },
                list: {
                    ...state.list,
                    ...action.payload
                }
            }
        case HOSPITAL_EVALUATION_ADD_ERROR:
            return {
                ...state,
                add: {
                    ...state.add,
                    loading: false,
                    type: action.payload.type,
                    message: action.payload.message
                }
            }
        case HOSPITAL_EVALUATION_TAB_SET:
            return {
                ...state,
                viewtab: {
                    ...state.viewtab,
                    tab: action.payload
                }
            }
        case HOSPITAL_EVALUATION_CAPACITY_INSTALL:
            return {
                ...state,
                loading: true,
                capacityinstall: {
                    ...state.capacityinstall
                }
            }
        case HOSPITAL_EVALUATION_CAPACITY_INSTALL_SUCCESS:
            return {
                ...state,
                loading: false,
                capacityinstall: {
                    ...state.capacityinstall,
                    ...action.payload
                }
            }
        case HOSPITAL_EVALUATION_CAPACITY_INSTALL_ERROR:
            return {
                ...state,
                loading: false,
                error: true
            }
        case HOSPITAL_EVALUATION_INFRASTRUCTURE:
            return {
                ...state,
                loading: true,
                infrastructure: {
                    ...state.infrastructure
                }
            }
        case HOSPITAL_EVALUATION_INFRASTRUCTURE_SUCCESS:
            return {
                ...state,
                loading: false,
                infrastructure: {
                    ...state.infrastructure,
                    ...action.payload
                }
            }
        case HOSPITAL_EVALUATION_INFRASTRUCTURE_ERROR:
            return {
                ...state,
                loading: false,
                error: true
            }
        case HOSPITAL_EVALUATION_HUMAN_TALENT:
            return {
                ...state,
                loading: true,
                humantalent: {
                    ...state.humantalent
                }
            }
        case HOSPITAL_EVALUATION_HUMAN_TALENT_SUCCESS:
            return {
                ...state,
                loading: false,
                humantalent: {
                    ...state.humantalent,
                    ...action.payload
                }
            }
        case HOSPITAL_EVALUATION_HUMAN_TALENT_ERROR:
            return {
                ...state,
                loading: false,
                error: true
            }
        case HOSPITAL_EVALUATION_PRODUCTION:
            return {
                ...state,
                loading: true,
                production: {
                    ...state.production
                }
            }
        case HOSPITAL_EVALUATION_PRODUCTION_SUCCESS:
            return {
                ...state,
                loading: false,
                production: {
                    ...state.production,
                    ...action.payload
                }
            }
        case HOSPITAL_EVALUATION_PRODUCTION_ERROR:
            return {
                ...state,
                loading: false,
                error: true
            }
        case HOSPITAL_EVALUATION_AVAILABILITY:
            return {
                ...state,
                loading: true,
                availability: {
                    ...state.availability
                }
            }
        case HOSPITAL_EVALUATION_AVAILABILITY_SUCCESS:
            return {
                ...state,
                loading: false,
                availability: {
                    ...state.availability,
                    ...action.payload
                }
            }
        case HOSPITAL_EVALUATION_AVAILABILITY_ERROR:
            return {
                ...state,
                loading: false,
                error: true
            }

        default:
            return { ...state };
    }
};